module.exports = __webpack_public_path__ + "static/media/csvIcon.b1e0515d.svg";